export const UMB_USER_WORKSPACE_ALIAS = 'Umb.Workspace.User';
export { UMB_USER_WORKSPACE_CONTEXT } from './user-workspace.context-token.js';
